import { render, staticRenderFns } from "./SubBrandPicker.vue?vue&type=template&id=30b7cf54"
import script from "./SubBrandPicker.vue?vue&type=script&lang=js"
export * from "./SubBrandPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports